// extracted by mini-css-extract-plugin
module.exports = {"HeaderCell":"HeaderCell_HeaderCell__1Ok5e","sorted":"HeaderCell_sorted__1sCwG","withIcon":"HeaderCell_withIcon__3DzeK","truncate":"HeaderCell_truncate__pi0rq"};